/*
 * @Author: MX
 * @Date: 2021-03-26 15:50:23
 * @Description:
 */
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import langs from './langs'
import store from '@store'
import {LANG_ELEMENT_MAP,DEFAULT_LANG} from '@constants'

import {changeLang} from "../utils/common"
Vue.use(VueI18n)

const lang = LANG_ELEMENT_MAP[store.state.base.lang]
const i18n = new VueI18n({
  locale: lang || process.env.VUE_APP_I18N_LOCALE || DEFAULT_LANG, // 初始未选择默认 en 英文
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || DEFAULT_LANG,
  messages: { ...langs },
})
import { bus } from '@utils/common'
bus.$on('langJsonChange', () => {
  const lang = LANG_ELEMENT_MAP[store.state.base.lang] || DEFAULT_LANG
  i18n.locale = lang || DEFAULT_LANG
  changeLang(lang || DEFAULT_LANG)
})

export default i18n
